/* -*- JS -*- */
// ------------------------------------------------------------------------
//
// This code is property of BioSilico Limited and is protected by
// copyright law and international treaties. Unauthorized
// reproduction or distribution of this file, or any portion of
// it may result in severe civil and criminal penalties, and will
// be prosecuted to the maximum extent possible under the law.
//
// = LIBRARY
//   HomepageJS
//
// = FILENAME
//   AuthenticatorComponent.jsx
//
// = AUTHOR
//   Who       When        Why/What
//   K. Plewa   09.11.2022  Development
//
// ------------------------------------------------------------------------

import React, { useState, useEffect, useRef } from "react";
import "@aws-amplify/ui-react/styles.css";
import "./AuthenticatorComponent.css";
import { Amplify, Auth } from "aws-amplify";
import { Authenticator } from "@aws-amplify/ui-react";
import RegionSelector from "./RegionSelector"; // Import the new component
import $ from "jquery";
import Cookie from "js-cookie";
import awsExportsUS from "../../aws-exports-US";
import awsExportsUK from "../../aws-exports-UK";
import axios from "axios";

// Function to determine configuration
const getAwsExports = () => {
  const savedRegion = localStorage.getItem("savedRegion");
  return savedRegion === "UK" ? awsExportsUK : awsExportsUS;
};

// Immediately configure Amplify
Amplify.configure(getAwsExports());

// ------------------------------------------------------------------------
// Create a separate component from Amplify Authenticator to prevent a render within a
// render in the LoginComponent that is caused by Amplify Authenticator
const AuthenticatorComponent = (props) => {
  const [myUser, setUser] = useState(null);
  const globalRegion = useRef("US");

  // ------------------------------------------------------------------------
  useEffect(() => {
    const savedRegion = localStorage.getItem("savedRegion");
    if (globalRegion.current !== savedRegion) {
      Amplify.configure(savedRegion === "UK" ? awsExportsUK : awsExportsUS);
    } else {
      Amplify.configure(
        globalRegion.current === "UK" ? awsExportsUK : awsExportsUS
      );
    }
    const isLoggedIn = localStorage.getItem("userLoggedIn");
    //if (isLoggedIn === "true") {
    //props.setShowSignInPage(false);
    //} else {
    //  props.setShowSignInPage(true);
    //}
    if (myUser !== null && isLoggedIn === "true") {
      passDataToLogInComponent(myUser);
    }
  }, []);
  // ------------------------------------------------------------------------
  // POTENTIALY UNNECESSARY
  const authenticatorRemoveLeavePageListener = () => {
    if (myUser !== null) {
      $(".container").attr("style", "display: none;");
    }
    props.removePageLeaveEvent();
  };
  window.authenticatorRemoveLeavePageListener =
    authenticatorRemoveLeavePageListener;
  // ------------------------------------------------------------------------.
  // Pass the token email and users name and surname to main.js to be saved
  // and passed to wasm after it has been loaded
  const passDataToLogInComponent = (data) => {
    localStorage.setItem("userLoggedIn", true);
    setUser(data);
    props.setShowSignInPage(false);
    props.passBack(data);
    //if (!window.hasWindowEventListenerWindow()) {
    // window.addPageLeaveEventWindow();
    //}
  };

  // ------------------------------------------------------------------------
  const cognitoSignOut = async () => {
    try {
      console.log("Sign out");
      localStorage.removeItem("userLoggedIn");
      Cookie.remove("agreedToPolicies");
      Cookie.remove("ageVerified");
      await Auth.signOut();
      props.removePageLeaveEvent();
      return true;
    } catch (error) {
      //if (!window.hasWindowEventListenerWindow()) {
      //  window.addPageLeaveEventWindow();
      // }
      console.log("error signing out: ", error);
      return false;
    }
  };
  // Need to make the function global so the WASM can access it.
  window.cognitoSignOut = cognitoSignOut;

  // ------------------------------------------------------------------------
  const handleStateChange = () => {
    authenticatorRemoveLeavePageListener();
  };

  // ------------------------------------------------------------------------
  const checkIfUserExists = async (username) => {
    let url =
      sessionStorage.getItem("userCloudURL").toString() +
      "cognitocheckuserexists?username=" +
      username;
    let config = {
      method: "get",
      url: url,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    try {
      let response = await axios(config);
      // Must check for exactly "=== true"
      if (response.data.userExists === true) {
        return true;
        // Could use just else{} but need to check for "=== false" incase error or unexpected return
      } else if (response.data.userExists === false) {
        return false;
      } else {
        return null;
      }
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response);
        console.log(error.response.data.Error);
        console.log(error.response.status);
        console.log(error.response.headers);
        return error.response.data.Error;
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
        return error.request;
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
      // Handle any other errors that may occur during the axios request or destructuring process
      console.error(error.data);
      return error;
    }
  };

  // ------------------------------------------------------------------------
  const formFields = {
    signIn: {
      username: {
        placeholder: "Enter your Email",
        labelHidden: true,
      },
      password: {
        placeholder: "Enter your Password",
        labelHidden: true,
      },
    },
    signUp: {
      given_name: {
        labelHidden: true,
        placeholder: "Enter your First Name",
        order: 1,
        isRequired: true,
      },
      family_name: {
        labelHidden: true,
        placeholder: "Enter your Family Name",
        order: 2,
        isRequired: true,
      },
      email: {
        labelHidden: true,
        placeholder: "Enter your Email",
        order: 3,
        isRequired: true,
      },
      password: {
        labelHidden: true,
        placeholder: "Enter your Password",
        order: 4,
        isRequired: true,
      },
      confirm_password: {
        labelHidden: true,
        placeholder: "Confirm your Password",
        order: 5,
        isRequired: true,
      },
    },
    forceNewPassword: {
      password: {
        placeholder: "Enter your Password:",
      },
    },
    forgotPassword: {
      username: {
        labelHidden: true,
      },
    },
  };

  // ------------------------------------------------------------------------
  const services = {
    async handleSignIn(input) {
      const { username, password } = input;

      try {
        // Try signing in with UK user pool configuration first
        Amplify.configure(awsExportsUK);
        const user = await Auth.signIn(username, password);
        if (user) {
          localStorage.setItem("savedRegion", "UK");
          setUser(user);
          passDataToLogInComponent(user);
          return user;
        }
      } catch (error) {
        if (error.code === "UserNotFoundException") {
          console.log("User not found in European, trying US pool...");
          try {
            // Try signing in with US user pool configuration
            Amplify.configure(awsExportsUS);
            const user = await Auth.signIn(username, password);
            if (user) {
              localStorage.setItem("savedRegion", "US");
              setUser(user);
              passDataToLogInComponent(user);
              return user;
            }
          } catch (error) {
            console.error(
              "User not found in either pool or authentication failed"
            );
            throw error;
          }
        } else {
          console.error("Error during UK pool sign-in:", error);
          throw error;
        }
      }
    },

    async handleSignUp(input) {
      console.log(`region selected ${globalRegion.current}`);
      const { username, password, attributes } = input;
      // Check if user exists in UK user pool
      Amplify.configure(awsExportsUK);
      const userExistsInUK = await checkIfUserExists(username, awsExportsUK);
      if (userExistsInUK === true) {
        throw new Error("User already exists in the UK region.");
      } else if (userExistsInUK === null) {
        throw new Error(
          `Error occured while sign-up. Please try again. Error: ${userExistsInUK}`
        );
      }

      // Check if user exists in US user pool
      Amplify.configure(awsExportsUS);
      const userExistsInUS = await checkIfUserExists(username, awsExportsUS);
      if (userExistsInUS === true) {
        throw new Error("User already exists in the US region.");
      } else if (userExistsInUS === null) {
        throw new Error(
          `Error occured while sign-up. Please try again. Error: ${userExistsInUS}`
        );
      }
      try {
        // Use selected region to configure Amplify dynamically
        if (globalRegion.current === "UK") {
          Amplify.configure(awsExportsUK);
          console.log("Using European user pool for sign-up");
        } else {
          Amplify.configure(awsExportsUS);
          console.log("Using US user pool for sign-up");
        }

        // Attempt to sign up
        const signUpResponse = await Auth.signUp({
          username,
          password,
          attributes,
          autoSignIn: {
            enabled: true,
          },
        });
        console.log("Sign-up successful:", signUpResponse);
        return signUpResponse; // Let Authenticator handle post-signup flow
      } catch (error) {
        console.error("Error during sign-up:", error);
        throw error; // Let Authenticator display the error
      }
    },
  };

  // ------------------------------------------------------------------------
  return (
    <div>
      {/* <div> */}
      <Authenticator
        className="amazon"
        services={services}
        formFields={formFields}
        components={{
          SignUp: {
            FormFields() {
              return (
                <>
                  {/* Re-use default `Authenticator.SignUp.FormFields` */}
                  <Authenticator.SignUp.FormFields />

                  {/* Append & require Terms and Conditions field to sign up  */}
                  <RegionSelector selectedRegion={globalRegion} />
                </>
              );
            },
          },
        }}
      >
        {({ user }) => {
          if (user && user.username) {
            setUser(user);
            passDataToLogInComponent(user);
            props.setShowSignInPage(false);
          }
        }}
      </Authenticator>
    </div>
  );
};

// ------------------------------------------------------------------------
export default React.memo(AuthenticatorComponent);
